export default function Machines_A_2 (number = 1) {
  return {
    name: '卫星配电站',
    icon: '/static/img/machines/a2.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_A/Machines_A_2.js